const quickListApi = {
  getQuickLists() { // lists for current user
    return `/quick-list`;
  },
  getQuickListSelectList() {
    return `/quick-list/templates/`;
  },
  getQuickListTemplate(id) {
    return `/quick-list/${id}/template`;
  },
  getQuickListCount(id) {
    return `/quick-list/${id}/count`;
  },
  getQuickListResult(id) {
    return `/quick-list/${id}/result`;
  },
  saveQuickList(id) {
    return `/quick-list/${id}/save`;
  },
  saveQuickListGroup() {
    return `/quick-list/group`;
  },
  deleteQuickList(id) {
    return `/quick-list/${id}/delete`;
  },
};

export default quickListApi;
